import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/pagesComponents/homePageComponents/HomePage'
import EventsPage from '@/components/pagesComponents/eventsPageComponents/EventsPage'
import NewsPage from '@/components/pagesComponents/newsPageComponents/NewsPage'
import SignPetitionPage from '@/components/pagesComponents/signPetitionPageComponents/SignPetitionPage'
import SocialWallPage from '@/components/pagesComponents/socialsPageComponents/SocialWallPage'
import SupportersPage from '@/components/pagesComponents/supportersPageComponents/SupportersPage'
import PaperPage from '@/components/pagesComponents/paperPageComponents/PaperPage'
import ErrorPage from '@/components/errorPageComponents/ErrorPage'
import ContestPage from '@/components/pagesComponents/contestPageComponents/ContestPage'
import VideosPage from '@/components/pagesComponents/videosPageComponents/VideosPage'
import InventoryMapPage from '@/components/pagesComponents/inventoryMapPageComponents/InventoryMapPage'
import GalleryPage from '../components/pagesComponents/galleryPageComponents/GalleryPage'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  routes: [
    {
      path: '/countdown',
      redirect: '/home'
    },
    {
      path: '/countdown/cassiano',
      redirect: '/home'
    },
    {
      path: '*',
      name: 'pageNotFound',
      component: ErrorPage,
      props: {default: ErrorPage}
    },
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home/:language?',
      name: 'MainPage',
      component: HomePage,
      props: {default: HomePage}
    },
    {
      path: '/events/:language?',
      name: 'eventsPage',
      component: EventsPage,
      props: {default: EventsPage}
    },
    {
      path: '/news/:language?',
      name: 'newsPage',
      component: NewsPage,
      props: {default: NewsPage}
    },
    {
      path: '/sign-petition/:language?',
      name: 'signPetitionPage',
      component: SignPetitionPage,
      props: {default: SignPetitionPage}
    },
    {
      path: '/social-wall/:language?',
      name: 'socialWall',
      component: SocialWallPage,
      props: {default: SocialWallPage}
    },
    {
      path: '/contest/:language?',
      name: 'contest',
      component: ContestPage,
      props: {default: ContestPage}
    },
    {
      path: '/supporters/:language?',
      name: 'supportersPage',
      component: SupportersPage,
      props: {default: SupportersPage}
    },
    {
      path: '/paper/:language?',
      name: 'paperPage',
      component: PaperPage,
      props: {default: PaperPage}
    },
    {
      path: '/videos-gallery/:language?',
      name: 'videosPage',
      component: VideosPage,
      props: {default: VideosPage}
    },
    {
      path: '/inventory-map/:language?',
      name: 'inventoryMapPage',
      component: InventoryMapPage,
      props: {default: InventoryMapPage}
    },
    {
      path: '/gallery/:language?',
      name: 'galleryPage',
      component: GalleryPage,
      props: {default: GalleryPage}
    },
    {
      path: '/valoriICH',
      name: 'valoriICH',
      // component: ValoriICH
      beforeEnter: (to, from, next) => {
        location.href = 'http://intangiblesearch.eu/alpfoodway-webdoc/'
      }
    },
    {
      path: '/ICHvalues',
      redirect: '/valoriICH'
    },
    {
      path: '/ICHValues',
      redirect: '/valoriICH'
    },
    {
      path: '/ichvalues',
      redirect: '/valoriICH'
    },
    {
      path: '/valoriich',
      redirect: '/valoriICH'
    },
    {
      path: '/valorich',
      redirect: '/valoriICH'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js